import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { getStyle } from './utils.es.js';
import styled from '@emotion/styled';

const HtmlCode = (_a) => {
    var { htmlCode, commonStyle } = _a, rest = __rest(_a, ["htmlCode", "commonStyle"]);
    return (jsx(Wrapper, Object.assign({ commonStyle: commonStyle }, rest, { children: jsx("div", { dangerouslySetInnerHTML: {
                __html: htmlCode,
            } }) })));
};
const Wrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)}
`);
HtmlCode.displayName = 'HtmlCode';

export { HtmlCode as H };
